import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_lots_grid_ComponentContextService } from './FootprintManager.lots_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Lots_lot_date_types_singleComponent } from './Lots.lot_date_types_single.component'


interface IFootprintManager_lots_gridComponentEntity {
  Id?: number, CreatedSysDateTime?: string, Description?: string, LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, ModifiedSysDateTime?: string, Notes?: string, ReceiveDate?: string, StatusId?: number, VendorLotId?: number, VendorLot?: { CreatedSysDateTime?: string, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, ModifiedSysDateTime?: string, Notes?: string, Vat?: string }, Status?: { Name?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }}

interface IFootprintManager_lots_gridComponentInParams {
  ownerIds?: number[], projectIds?: number[], materialIds?: number[], statusIds?: number[]}


class FootprintManager_lots_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_lots_gridComponent;
  entity: IFootprintManager_lots_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: null,
    LookupCode: null,
    Status_Name: null,
    Description: null,
    CreatedSysDateTime: null,
    LastReceiveDate: null,
    ModifiedSysDateTime: null,
    ReceiveDate: null,
    Notes: null,
    VendorLot_LookupCode: null,
    VendorLot_Description: null,
    VendorLot_ExpirationDate: null,
    VendorLot_ManufactureDate: null,
    VendorLot_Notes: null,
    Material_LookupCode: null,
    Material_Name: null,
    Material_Description: null,
    Material_Project_Name: null,
    Material_Project_Owner_Name: null,
  }



  constructor(
    grid: FootprintManager_lots_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_lots_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Status_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Status_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedSysDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedSysDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LastReceiveDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LastReceiveDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedSysDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedSysDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ReceiveDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ReceiveDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorLot_LookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorLot_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorLot_Description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorLot_Description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorLot_ExpirationDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorLot_ExpirationDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorLot_ManufactureDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorLot_ManufactureDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorLot_Notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorLot_Notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Material_LookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Material_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Material_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Material_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Material_Description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Material_Description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Material_Project_Name = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Material_Project_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Material_Project_Owner_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Material_Project_Owner_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_lots_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_lots_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      ownerIds:  $grid.inParams.ownerIds ,
      projectIds:  $grid.inParams.projectIds ,
      materialIds:  $grid.inParams.materialIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      statusIds:  $grid.inParams.statusIds ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      dateType:  $grid.filters.date_type.control.value ,
      lotIds:  null ,
      vendorLotIds:  null ,
    };
    const data = await this.$datasources.Lots.ds_lots_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_lots_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.LookupCode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.Status_Name.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.Description.displayControl as TextModel).text = $row.entity.Description;
    (this.cells.Notes.displayControl as TextModel).text = $row.entity.Notes;
    (this.cells.VendorLot_LookupCode.displayControl as TextModel).text = $row.entity.VendorLot?.LookupCode;
    (this.cells.VendorLot_Description.displayControl as TextModel).text = $row.entity.VendorLot?.Description;
    (this.cells.VendorLot_Notes.displayControl as TextModel).text = $row.entity.VendorLot?.Notes;
    (this.cells.Material_LookupCode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.Material_Name.displayControl as TextModel).text = $row.entity.Material?.Name;
    (this.cells.Material_Description.displayControl as TextModel).text = $row.entity.Material?.Description;
    (this.cells.Material_Project_Name.displayControl as TextModel).text = $row.entity.Material?.Project?.Name;
    (this.cells.Material_Project_Owner_Name.displayControl as TextModel).text = $row.entity.Material?.Project?.Owner?.Name;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'LookupCode' : {
        this.on_lot_clicked();
        break;
      }
      case 'Material_LookupCode' : {
        this.on_material_clicked();
        break;
      }
      case 'Material_Project_Name' : {
        this.on_project_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_lots_gridComponentRowModel,
  $grid: FootprintManager_lots_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_lots_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'lots_grid.on_row_data_loaded');
  // O.Arias - 08/14/2023
  
  // Set Date/Time Formats
  const format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  if ($utils.isDefined(format)) {
  
      if ($utils.isDefined($row.entity.CreatedSysDateTime)) {
          $row.cells.CreatedSysDateTime.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.ModifiedSysDateTime)) {
          $row.cells.ModifiedSysDateTime.displayControl.text = $utils.date.format($row.entity.ModifiedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.LastReceiveDate)) {
          $row.cells.LastReceiveDate.displayControl.text = $utils.date.format($row.entity.LastReceiveDate, format);
      };
  
      if ($utils.isDefined($row.entity.ReceiveDate)) {
          $row.cells.ReceiveDate.displayControl.text = $utils.date.format($row.entity.ReceiveDate, format);
      };
  
      if ($utils.isDefined($row.entity.VendorLot.ManufactureDate)) {
          $row.cells.VendorLot_ManufactureDate.displayControl.text = $utils.date.format($row.entity.VendorLot.ManufactureDate, format);
      };
  
      if ($utils.isDefined($row.entity.VendorLot.ExpirationDate)) {
          $row.cells.VendorLot_ExpirationDate.displayControl.text = $utils.date.format($row.entity.VendorLot.ExpirationDate, format);
      };
  
  };
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_lots_gridComponentRowModel,
  $grid: FootprintManager_lots_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_lots_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'lots_grid.on_lot_clicked');
  //O.Arias - 08/14/2023
  
  $shell.FootprintManager.opensingle_lot_hub({lotId: $row.entity.Id});
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_lots_gridComponentRowModel,
  $grid: FootprintManager_lots_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_lots_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'lots_grid.on_material_clicked');
  //O.Arias - 08/14/2023
  
  $shell.FootprintManager.opensingle_material_hub({materialId: $row.entity.MaterialId});
  }
  on_project_clicked(event = null) {
    return this.on_project_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_clickedInternal(
    $row: FootprintManager_lots_gridComponentRowModel,
  $grid: FootprintManager_lots_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_lots_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'lots_grid.on_project_clicked');
  //O.Arias - 08/14/2023
  
  $shell.FootprintManager.opensingle_project_hub({projectId: $row.entity.Material.ProjectId});
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Lots_lot_date_types_singleComponent),
  ],
  selector: 'FootprintManager-lots_grid',
  templateUrl: './FootprintManager.lots_grid.component.html'
})
export class FootprintManager_lots_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_lots_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_lots_gridComponentInParams = { ownerIds: [], projectIds: [], materialIds: [], statusIds: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'LookupCode', 'Lot', false, false, null, false),       Status_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Status_Name', 'Status', false, false, null, false),       Description: new GridHeaderModel(new HeaderStyles(null, null), 'Description', 'Description', false, false, null, false),       CreatedSysDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedSysDateTime', 'Created date', false, false, null, false),       LastReceiveDate: new GridHeaderModel(new HeaderStyles(null, null), 'LastReceiveDate', 'Last receive date', false, false, null, false),       ModifiedSysDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedSysDateTime', 'Modified date', false, false, null, false),       ReceiveDate: new GridHeaderModel(new HeaderStyles(null, null), 'ReceiveDate', 'Receive date', false, false, null, false),       Notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', 'Notes', false, false, null, false),       VendorLot_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'VendorLot_LookupCode', 'Vendor lot', false, false, null, false),       VendorLot_Description: new GridHeaderModel(new HeaderStyles(null, null), 'VendorLot_Description', 'Vendor lot description', false, false, null, false),       VendorLot_ExpirationDate: new GridHeaderModel(new HeaderStyles(null, null), 'VendorLot_ExpirationDate', 'Expiration date', false, false, null, false),       VendorLot_ManufactureDate: new GridHeaderModel(new HeaderStyles(null, null), 'VendorLot_ManufactureDate', 'Manufacture date', false, false, null, false),       VendorLot_Notes: new GridHeaderModel(new HeaderStyles(null, null), 'VendorLot_Notes', 'Vendor lot notes', false, false, null, false),       Material_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'Material_LookupCode', 'Material', false, false, null, false),       Material_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Material_Name', 'Material name', false, false, null, false),       Material_Description: new GridHeaderModel(new HeaderStyles(null, null), 'Material_Description', 'Material description', false, false, null, false),       Material_Project_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Material_Project_Name', 'Project', false, false, null, false),       Material_Project_Owner_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Material_Project_Owner_Name', 'Owner', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_lots_gridComponentRowModel[] = [];

  @Input('ownerIds') set $inParams_ownerIds(value: any) {
    this.inParams['ownerIds'] = value;
  }
  get $inParams_ownerIds(): any {
    return this.inParams['ownerIds'] ;
  }
  @Input('projectIds') set $inParams_projectIds(value: any) {
    this.inParams['projectIds'] = value;
  }
  get $inParams_projectIds(): any {
    return this.inParams['projectIds'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date from', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date to', false, false),
    date_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_type'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_lots_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Lots grid';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      ownerIds:  $grid.inParams.ownerIds ,
      projectIds:  $grid.inParams.projectIds ,
      materialIds:  $grid.inParams.materialIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      statusIds:  $grid.inParams.statusIds ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      dateType:  $grid.filters.date_type.control.value ,
      lotIds:  null ,
      vendorLotIds:  null ,
    };
    try {
      const data = await this.$datasources.Lots.ds_lots_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_lots_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_lots_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_lots_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
